export default __webpack_public_path__ + "static/bakery-presentation-2ac2098eee3f5bba44d63106b91ae980.png";